import { render, staticRenderFns } from "./SimBajaIndividualBase.vue?vue&type=template&id=c7e1974c&"
import script from "./SimBajaIndividualBase.vue?vue&type=script&lang=ts&"
export * from "./SimBajaIndividualBase.vue?vue&type=script&lang=ts&"
import style0 from "./SimBajaIndividualBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports